/* Bundle + Save LP — category-chip filtering + sticky CTA reveal.
   Promo on/off is server-rendered (Liquid stamps .is-promo / .is-evergreen on
   each section root from settings.bundle_save_promo_on), so JS does not toggle
   promo state. Guarded against double-init. */
(function () {
  if (window.__bsLpInit) return;
  window.__bsLpInit = true;

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  function reduceMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  ready(function () {
    /* Category chip filtering. A chip bar carries data-bs-target="<gridSectionId>".
       Groups inside the grid carry data-group="<key>"; chips carry data-filter="<key>". */
    document.querySelectorAll('[data-bs-chips]').forEach(function (bar) {
      var chips = Array.prototype.slice.call(bar.querySelectorAll('.bs-lp__chip'));
      var gridId = bar.getAttribute('data-bs-target');
      var grid = gridId ? document.getElementById(gridId) : null;
      if (!grid) return;
      var countEl = grid.querySelector('[data-bs-count]');

      function apply(key, chip) {
        var shown = 0;
        grid.querySelectorAll('.bs-lp__group').forEach(function (sec) {
          var match = (key === 'all' || sec.getAttribute('data-group') === key);
          sec.style.display = match ? '' : 'none';
          if (match) shown += sec.querySelectorAll('.bs-lp__card-cell').length;
        });
        if (countEl) {
          countEl.textContent = (key === 'all')
            ? 'All ' + shown + ' bundles'
            : shown + (shown === 1 ? ' bundle · ' : ' bundles · ') + (chip ? chip.textContent.trim() : '');
        }
      }

      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var key = chip.getAttribute('data-filter');
          chips.forEach(function (c) { c.classList.remove('is-active'); c.setAttribute('aria-selected', 'false'); });
          chip.classList.add('is-active');
          chip.setAttribute('aria-selected', 'true');
          apply(key, chip);
          grid.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'start' });
        });
      });

      /* initial count (all) */
      apply('all', null);
    });

    /* Sticky CTA reveals once the trigger element scrolls above the viewport top. */
    var sticky = document.querySelector('[data-bs-sticky]');
    var trigger = document.querySelector('[data-bs-sticky-trigger]');
    if (sticky && trigger && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', entries[0].boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(trigger);
    }
  });
})();
